import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import {Translate} from "../../../../config/Translate";
import IconButton from "@material-ui/core/IconButton/IconButton";
import Divider from "@material-ui/core/Divider/Divider";
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import ChevronLeftRoundedIcon from '@material-ui/icons/ChevronLeftRounded';
import axios from "axios";
import {defaultVariabls} from "../../../../config";
import {connect, setStore} from "trim-redux";
import AppCardLoaderFields from "../../../components/Skeletons/AppCardLoaderFields";
import List from "@material-ui/core/List/List";
import {ListItem} from "@material-ui/core";
import ListItemAvatar from "@material-ui/core/ListItemAvatar/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar/Avatar";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction/ListItemSecondaryAction";
import Checkbox from "@material-ui/core/Checkbox/Checkbox";
import Typography from "@material-ui/core/Typography/Typography";
import Alert from "@material-ui/lab/Alert/Alert";
import DialogActions from "@material-ui/core/DialogActions/DialogActions";
import SaveRoundedIcon from "@material-ui/icons/SaveRounded";
import LoadingButton from "../../../components/elements/LoadingButton";
import {withRouter} from "react-router";
import {withSnackbar} from "notistack";
import {withStyles} from "@material-ui/core/styles";
import {Styles} from "../../../../config/design/styles";

class ParticipateInFestivalButton extends React.Component{
    state = {
        open: false,
        id:this.props.id,
        products:[],
        selected_products:[],
        loading:false,
        SubmitLoading:false,
    };
    componentDidMount(){
        this.setState({
            id:this.props.id,
        })
        this.loadData();
    }
    async loadData(){
        let loginToken = localStorage.getItem('ACT');
        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.get(`${defaultVariabls.url}/my-products/getAll/${this.props.id}`, config)
                .then(response => {
                    this.setState({
                        products:response.data.products,
                        selected_products:response.data.selected_products,
                        loading:false,
                    })

                }).catch(error => {
                    this.setState({
                        loading:false
                    })
                })
        }else {
            setStore({
                isAuth : false,
                user : null,
            });
        }
    }
    componentDidUpdate(prevProps){
        if(this.state.id !== this.props.id){
            this.setState({
                id: this.props.id
            })
        }
    }
    async toggleOpen(){
        await this.setState({
            open: !this.state.open
        })
        if(this.state.open === true){
            this.setState({
                run:true
            })
        }else{
            this.setState({
                run:false
            })
        }
    }
    async handleReload(){
        await this.toggleOpen();
    }
    async handleChangeSelected(id){
        let {selected_products} = this.state;
        let index = selected_products.indexOf(id);
        if (index > -1) {
            selected_products.splice(index, 1);
        }else{
            selected_products.push(id)
        }
        await this.setState({
            selected_products
        })
    }
    async handleAddAllProducts(){
        let {selected_products,products} = this.state;
        selected_products = [];
        await products.map(product =>{
            selected_products.push(product.id)
        })
        await this.setState({
            selected_products
        })
    }
    async handleSubmit(e){
        this.setState({
            SubmitLoading: true
        })
        e.preventDefault();
        let {selected_products} = this.state;
        let {id} = this.props;
        let data = new FormData();
        data.append('selected_products', JSON.stringify(selected_products));
        data.append('id', id);

        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        await axios.post(`${defaultVariabls.url}/participate/festival`, data, config)
            .then(response => {
                this.props.enqueueSnackbar(Translate.dataEdited, {
                    variant: 'success',
                });
                this.handleReload();
                this.setState({
                    SubmitLoading: false
                })
            })
            .catch(error => {
                console.log(error.response)
                this.props.enqueueSnackbar(Translate.dataEditingFailed, {
                    variant: 'error',
                });
                this.setState({
                    loading:false,
                    SubmitLoading: false,
                });
            });

    }
    render(){
        let {open,loading,products,selected_products,SubmitLoading} = this.state;
        return (
            <>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => this.toggleOpen()}
                    endIcon={<ChevronLeftRoundedIcon/>}
                    size={"small"}
                    style={{marginBottom:5,marginRight:5}}
                >
                    {Translate.participate}
                </Button>
                <Dialog
                    open={open}
                    onClose={() => this.toggleOpen()}
                    aria-labelledby="form-dialog-title"
                    fullWidth
                    maxWidth="sm"
                >
                    <DialogTitle id="form-dialog-title">
                        {
                            Translate.participate
                        }
                        <IconButton
                            onClick={() => this.toggleOpen()}
                            style={{position:"absolute",left:15,top:15}}
                            size="small"
                        >
                            <CloseRoundedIcon fontSize="small"/>
                        </IconButton>
                    </DialogTitle>
                    <Divider/>
                    <DialogContent>
                        <Alert>{Translate.participateDesc}</Alert>
                        {
                            !!loading ? <AppCardLoaderFields/>
                                :
                                <>
                                    {
                                        !!products.length ?
                                            <>
                                                <Button
                                                    color="primary"
                                                    size="small"
                                                    style={{marginTop:10}}
                                                    variant="contained"
                                                    onClick={()=> this.handleAddAllProducts()}
                                                >
                                                    {Translate.chooseAll}
                                                </Button>
                                                <List dense >
                                                    {products.map((product) => {
                                                        return (
                                                            <ListItem key={product.id} button onClick={()=> this.handleChangeSelected(product.id)}>
                                                                <ListItemAvatar>
                                                                    <Avatar
                                                                        src={`${defaultVariabls.uploads}/FileManager/${product.thumbnail.name}_small.${product.thumbnail.extension}`}
                                                                    />
                                                                </ListItemAvatar>
                                                                <ListItemText primary={product.name} />
                                                                <ListItemSecondaryAction>
                                                                    <Checkbox
                                                                        edge="end"
                                                                        checked={selected_products.indexOf(product.id) !== -1}
                                                                    />
                                                                </ListItemSecondaryAction>
                                                            </ListItem>
                                                        );
                                                    })}
                                                </List>
                                            </>
                                            :
                                            <>
                                            <Typography>{Translate.noProduct}</Typography>
                                            </>
                                    }

                                </>
                        }
                    </DialogContent>
                    <DialogActions>
                        <LoadingButton
                            variant="contained"
                            color="primary"
                            startIcon={<SaveRoundedIcon/>}
                            onClick={this.handleSubmit.bind(this)}
                            loading={SubmitLoading}
                        >
                            {Translate.save}
                        </LoadingButton>
                    </DialogActions>
                </Dialog>
            </>
        );
    }
}
const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user
});
export default withRouter(withSnackbar(withStyles(Styles)(connect(mstp)(ParticipateInFestivalButton))));
